import type { SVGProps } from "react";

export default function PlusIcon({
  width = 12,
  height = 12,
  ...rest
}: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.224 5.99951H0.775879M6 11.2235L6 0.775391"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
